import { Smile, HeadphonesIcon, Plug, PiggyBank, ShoppingCart, UserCheck } from "lucide-react";
import { Card, CardContent } from "@/components/ui/card";
import { useLanguage } from "@/hooks/useLanguage";

const iconMap = [Smile, HeadphonesIcon, Plug, PiggyBank, ShoppingCart, UserCheck];
const colorMap = [
  { color: "text-accent", bgColor: "bg-accent/10" },
  { color: "text-primary", bgColor: "bg-primary/10" },
  { color: "text-orange-500", bgColor: "bg-orange-500/10" },
  { color: "text-violet-500", bgColor: "bg-violet-500/10" },
  { color: "text-accent", bgColor: "bg-accent/10" },
  { color: "text-primary", bgColor: "bg-primary/10" },
];

const AboutBenefits = () => {
  const { t, tObject } = useLanguage();
  const benefits = tObject<Array<{ title: string; description: string }>>("aboutBenefits.items");

  return (
    <section className="py-20 bg-background">
      <div className="container mx-auto px-4 md:px-6">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold text-primary mb-4">{t("aboutBenefits.title")}</h2>
          <p className="text-lg text-muted-foreground max-w-2xl mx-auto">{t("aboutBenefits.description")}</p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 max-w-5xl mx-auto">
          {benefits.map((benefit, index) => {
            const Icon = iconMap[index] || Smile;
            const colors = colorMap[index] || colorMap[0];
            return (
              <Card key={index} className="border-border/50 hover:shadow-lg transition-all hover:-translate-y-1 text-center">
                <CardContent className="p-6">
                  <div className={`w-14 h-14 ${colors.bgColor} rounded-xl flex items-center justify-center mx-auto mb-4`}>
                    <Icon className={`w-7 h-7 ${colors.color}`} />
                  </div>
                  <h3 className="text-lg font-semibold text-foreground mb-2">{benefit.title}</h3>
                  <p className="text-muted-foreground text-sm">{benefit.description}</p>
                </CardContent>
              </Card>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default AboutBenefits;
